import { render, staticRenderFns } from "./studentsByGender.vue?vue&type=template&id=5ae23cdb&scoped=true&"
import script from "./studentsByGender.js?vue&type=script&lang=js&"
export * from "./studentsByGender.js?vue&type=script&lang=js&"
import style0 from "./studentsByGender.scss?vue&type=style&index=0&id=5ae23cdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae23cdb",
  null
  
)

export default component.exports